<template>
  <v-app>
    <dashboard-core-app-bar v-model="expandOnHover" />

    <dashboard-core-drawer :expand-on-hover.sync="expandOnHover" />

    <dashboard-core-view />

    <!--<dashboard-core-settings v-model="expandOnHover" />-->
    <loader />
    <toast />
  </v-app>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'DashboardIndex',

    components: {
      Loader: () => import('../../components/Loader'),
      Toast: () => import('../../components/Toast'),
      DashboardCoreAppBar: () => import('./components/core/AppBar'),
      DashboardCoreDrawer: () => import('./components/core/Drawer'),
      // DashboardCoreSettings: () => import('./components/core/Settings'),
      DashboardCoreView: () => import('./components/core/View'),
    },

    data: () => ({
      expandOnHover: false,
    }),
    computed: {
      ...mapState(['darkMode']),
    },
    created () {
      // this.$vuetify.theme.dark = this.darkMode
    },
  }
</script>
